import { API } from '@/config/api.js'

export default {
  namespaced: true,

  state: () => ({
    loading: false,
    error: null,
    user: null,
    token: null,
    uid: null,
    isAuthenticated: false
  }),

  getters: {
    user: (state) => state.user,
    isAuthenticated: (state) => state.isAuthenticated,
  },

  mutations: {
    SET_IS_AUTH (state, value) {
      state.isAuthenticated = value
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, value) {
      state.error = value
    },
    SET_USER(state, value) {
      state.user = value
    },
    SET_TOKEN(state, value) {
      state.token = value
    },
    SET_UID(state, value) {
      state.uid = value
    },
    LOGOUT(state) {
      state.user = null
      state.token = null
    }
  },

  actions: {
    async login({ commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const res = await fetch(`${API.fullUrl}/user/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        // обработка ошибок сразу
        if (!res.ok) {
          const { message } = await res.json().catch(() => ({}))
          const errorMsg = message || 'Ошибка авторизации'
          commit('SET_ERROR', errorMsg)
          throw new Error(errorMsg)
        }

        const { data } = await res.json()
        if (!data) {
          throw new Error('Некорректный ответ сервера')
        }

        const { token, uid, ...user } = data

        commit('SET_USER', user.data || null)
        commit('SET_TOKEN', token || null)
        commit('SET_UID', uid || null)
        commit('SET_IS_AUTH', true)

        if (token && uid) {
          localStorage.setItem('token', token)
          localStorage.setItem('uid', uid)
        }

        return data
      } catch (err) {
        commit('SET_ERROR', err.message || 'Неизвестная ошибка')
        commit('SET_IS_AUTH', false)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    logout({ commit }) {
      commit('LOGOUT')
      commit('SET_IS_AUTH', false)
      localStorage.removeItem('token')
    },

    async fetchCurrentUser({ state, commit, dispatch}) {
      if (!state.token || !state.uid) return

      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      const payload = {
        token: state.token,
        uid: state.uid
      }

      try {
        const res = await fetch(`${API.fullUrl}/user/me`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${state.token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })

        if (!res.ok) {
          const data = await res.json().catch(() => ({}))
          const message = data.message || 'Не удалось получить данные пользователя'
          commit('SET_ERROR', message)
          throw new Error(message)
        }

        const user = await res.json()
        commit('SET_USER', user.data)
        commit('SET_IS_AUTH', true)
      } catch (err) {
        commit('SET_ERROR', err.message)
        commit('SET_IS_AUTH', false)
        dispatch('logout')
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateUser({ state, commit }, payload) {
      if (!state.token) throw new Error('Не авторизован')


      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const res = await fetch(`${API.fullUrl}/user/update-user`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.token}`
          },
          body: JSON.stringify({ uid: state.uid, ...payload })
        })

        if (!res.ok) {
          const data = await res.json().catch(() => ({}))
          const message = data.message || 'Ошибка обновления данных'
          commit('SET_ERROR', message)
          throw new Error(message)
        }

        let user = await res.json()
        commit('SET_USER', user.data || null)
        commit('SET_TOKEN', user.data.token || null)
        commit('SET_UID', user.data.uid || null)

        if (user.data.token && user.data.uid) {
          localStorage.setItem('token', user.data.token)
          localStorage.setItem('uid', user.data.uid)
        }

        return user.data
      } catch (err) {
        commit('SET_ERROR', err.message)
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async init({ commit, dispatch }) {
      const token = localStorage.getItem('token')
      const uid = localStorage.getItem('uid')
      if (token && uid) {
        commit('SET_TOKEN', token)
        commit('SET_UID', uid)
        commit('SET_IS_AUTH', true)
        await dispatch('fetchCurrentUser')
      }
      else {
        commit('SET_IS_AUTH', false)
      }
    }
  }
}
